<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-col cols="12">
            <h4>Prazo dos alertas de vencimentos</h4>
            <fieldset class="font-weight-bold text-muted small">
              Defina com quantos dias de antecedência ao vencimento deve ser disparado o alerta e o intervalo dos lembretes por e-mail
            </fieldset>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <hr
              class="mx-0 mt-0 mb-2"
              style="border-top: 1px solid #a3a4a66b !important;"
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-for="controle in controles"
            :key="controle.value"
            cols="12"
          >
            <controle-vencimento
              ref="controle"
              :value="controle"
              :tipo-certificado="tipoCertificado"
              :mostrar-adicionar="mostrarAdicionar"
              @add-item="addItem"
              @remove="removeControle"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
</style>

<script>

import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoControleVencimento/services/api'

export default {
  name: 'ParametrizacaoControleVencimento',
  components: {
    CadastroBase,
    ControleVencimento: () => import('./ControleVencimento/ControleVencimento.vue'),
  },
  data() {
    return {
      controles: [],
      tipoCertificado: [
        { value: '1', text: 'Certificado A1 e-CNPJ', disabled: false },
        { value: '3', text: 'Certificado A3 e-CNPJ', disabled: false },
        { value: '2', text: 'Certificado A1 e-CPF', disabled: false },
        { value: '4', text: 'Certificado A3 e-CPF', disabled: false }],
      mostrarAdicionar: false,
    }
  },
  created() {
    api.getControleVencimento()
      .then(result => {
        if (result.data) {
          this.controles = result.data
          this.mostrarBtnAdicionar()
        }
      })
  },
  methods: {
    salvar() {
      return new Promise((resolve, reject) => {
        this.removerControleVazio()
        if (this.controles && !this.controles.some(s => s.tipo && !s.diasAntesVencimento)) {
          api.salvarControleVencimento(this.controles).then(success => {
            if (success) {
              resolve('Controle de vencimento salvo')
            } else {
              this.$erro('Preencha os campos corretamente!')
            }
          })
            .catch(err => {
              reject(err)
            })
        } else {
          this.$erro('Preencha os campos corretamente!')
        }
      })
    },
    addItem() {
      if (this.controles.some(s => !s.tipo)) {
        const index = this.controles.findIndex(f => !f.tipo)
        this.controles[index].erro = true
      }
      if (this.controles.length < 4 && !this.controles.some(s => !s.tipo)) {
        this.controles.push({
          id: 0,
          emailCC: [],
          tipo: null,
          tipoDescricao: null,
          diaCobrancaDocumentos: null,
          intervaloCobranca: null,
          erro: false,
        })
      }
      this.mostrarBtnAdicionar()
    },
    removeControle(value) {
      // eslint-disable-next-line no-param-reassign
      const index = this.controles
        .findIndex(f => (f.tipo && value.tipo === f.tipo) || (!f.tipo && f.id === value.id))
      const indexTipo = this.tipoCertificado.findIndex(f => f.value === value.tipo)
      if (indexTipo >= 0) {
        this.$set(this.tipoCertificado[indexTipo], 'disabled', false)
      }
      if (index >= 0) {
        this.controles.splice(index, 1)
      }

      if (this.controles.length === 0) {
        this.addItem()
      }
      this.mostrarBtnAdicionar()
    },
    mostrarBtnAdicionar() {
      if (this.controles.length < 4) {
        this.mostrarAdicionar = true
      } else {
        this.mostrarAdicionar = false
      }
    },
    removerControleVazio() {
      if (this.controles.length > 1) {
        const index = this.controles.findIndex(f => !f.tipo)
        if (index >= 0) {
          this.controles.splice(index, 1)
        }
      }
    },
  },
}
</script>
